export default {
  path: '/onboarding-invitation',
  redirect: '/sign-up',
};
